import React, { Component } from 'react';
import { func, string } from 'prop-types';
import Input from 'ps-components/Input/Input';
import './RuleNameEditor.scss';

class RuleNameEditor extends Component {
  static propTypes = {
    cancelRuleNameEditing: func,
    onEnter: func,
    setRuleName: func,
    ruleName: string,
    saveRuleName: func,
    tempName: string
  };

  componentDidMount() {
    const { onEnter } = this.props;
    document.getElementById('edit__rule-name').addEventListener('keypress', e => onEnter(e));
  }

  UNSAFE_componentWillUnmount() {
    const { onEnter } = this.props;
    document.getElementById('edit__rule-name').removeEventListener('keypress', e => onEnter(e));
  }

  render() {
    const { cancelRuleNameEditing, ruleName, saveRuleName, setRuleName, tempName } = this.props;

    return (
      <div className="edit__actions" id="edit__rule-name">
        <Input
          autoFocus
          className="edit__input"
          onChange={e => setRuleName(e)}
          type="text"
          value={tempName.length ? tempName : ruleName}
        />
        <i className="edit__icon icon-check" onClick={saveRuleName} />
        <i className="edit__icon icon-cancel" onClick={cancelRuleNameEditing} />
      </div>
    );
  }
}

export default RuleNameEditor;
